
export const onWindowOpen = (data,resp) => {
        // window.open(`../../${data[2]}?uid=${data[1]}${resp}`, "_blank");

        const url =`../../${data[2]}`

        const form = document.createElement("form");
        form.target = "_blank";
        form.method = "POST";
        form.action = url;
        form.style.display = "none";

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = 'uid';
        input.value = `${data[1]}${resp}`;
        form.appendChild(input);
        
    
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    
}
